import React, { useState, useEffect } from "react";
import { Container, Row, Col  } from "react-bootstrap";
import { Link } from "@StarberryUtils";
import axios from "axios"
import Modal from 'react-bootstrap/Modal'
import TimeAgo from 'react-timeago'
import frenchStrings from 'react-timeago/lib/language-strings/en'
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter'
import GetRating from './getrating';
import ScrollAnimation from "react-animate-on-scroll";
import GoogleBannerImgD from "../images/home/google-reviews-dark-d.png"
import GoogleBannerImgT from "../images/home/google-reviews-dark-t.png"
import GoogleBannerImgM from "../images/home/google-reviews-dark-m.png"
import { Reviews_Page_Url } from "@Components/common/site/constants";
import { inViewOptions } from './utils/animations';
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";
import Slider from "react-slick";
import wordsToNumbers from 'words-to-numbers';
import { ElfsightWidget } from 'react-elfsight-widget';
const containerVariants = {
    hidden: {
        opacity: 0
    },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.4,
            ease: [0.33, 1, 0.68, 1],
            duration: 0.4
        }
    }
}

const items = {
    hidden: {
        opacity: 0,
        y: 40
    },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            ease: [0.33, 1, 0.68, 1],
            duration: 0.3
        }
    }
}

const MotionColumn = motion(Col)

const postsPerPage = 18;
let arrayForHoldingPosts = [];

const Ethics = (props) => {
    const settings = {
        responsive: [
            {
                breakpoint: 992,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  infinite: true,
                  dots:true,
                },
              },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots:true,
            },
          },
        ],
      }

    /**** set here local states */
    const [] = useState(0);

    const [postsToShow, setPostsToShow] = useState([]);
    const [next, setNext] = useState(18);

    const [] = useState(true);
    const [testimonials, setTestimonials] = useState([])

    const loopWithSlice = (start, end) => {
        const slicedPosts = testimonials.slice(start, end);
        arrayForHoldingPosts = [...arrayForHoldingPosts, ...slicedPosts];
        setPostsToShow(arrayForHoldingPosts);
    };

    const handleShowMorePosts = () => {
        loopWithSlice(next, next + postsPerPage);
        setNext(next + postsPerPage);
    };



    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const [reviewid, setReviewid] = useState(false);
    const formatter = buildFormatter(frenchStrings)
    const handleShow = (event) => {
        setReviewid(event);
        setShow(true);
    }
    const getitems = async url => {
        try {
            const { data } = await axios.get(url, {
                headers: {
                Authorization: `Bearer ${process.env.GATSBY_STRAPI_FORM_TOKEN}`,
                }
            })// could be from env files
            setTestimonials(data)
        } catch (error) {
            // cache it if fail/error;
            console.error(error)
        }
    }
    useEffect(() => {
        loopWithSlice(0, postsPerPage);
    }, [testimonials]);

    useEffect(() => {
        let url = `${process.env.GATSBY_STRAPI_SRC}/google-review-reviews`
        getitems(url);
    }, [])
    var testimonial_count = testimonials ? testimonials.length : 0;
    var rating_count = 0;
    testimonials && testimonials.length > 0 && testimonials.map((item, ind) => {
      rating_count += parseInt(wordsToNumbers(item.starRating));
    })
    var rating_avg = rating_count / testimonial_count;
    return (
        <InView {...inViewOptions}>
            {({ ref, inView }) => (
                <motion.section
                    ref={ref}
                    initial="hidden"
                    animate={inView ? "visible" : "hidden"}
                    variants={containerVariants}
                >
                    <section className="review-listing customer-google-block">
                        <React.Fragment>
                            <Container>
                                <ElfsightWidget widgetId="dee01cec-99e2-4821-9a6a-ff88c2554da6" lazy />
                            </Container>
                        </React.Fragment>
                    </section>
                </motion.section>
            )}
        </InView>
    )
}
export default Ethics;